import { call, put, takeLatest } from 'redux-saga/effects'
import { submitFeeSucess } from './action';
import { select } from 'redux-saga/effects';
import { Api } from './api'
import {
  DECODE_ZIP,
  DECODE_VIN,
  SUBMIT_FEES_FORM,
  SAVE_FEES_FORM_DATA,
  DECODE_ZIP_FAILED,
  DECODE_VIN_FAILED,
  SUBMIT_FEES_FAILED,
} from './types'
import { UPDATE_LOCATION_SELECT_OPTIONS, UPDATE_VEHICLE_INFO_OPTIONS } from '../forms/types';

function* decodeZip(action) {
  try {
    const response = yield call(Api.decodeZip, action.payload);

    if (response?.status === 200) {
      yield put({
        type: UPDATE_LOCATION_SELECT_OPTIONS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: DECODE_ZIP_FAILED,
        payload: { error: response?.data?.message },
      });
    }

  } catch (error) {
    yield put({
      type: DECODE_ZIP_FAILED,
      payload: {
        error: error.message || 'Unexpected error',
      },
    });
  }
}

function* decodeVin(action) {
  try {
    const response = yield call(Api.decodeVin, action.payload);

    if (response?.status === 200) {
      yield put({
        type: UPDATE_VEHICLE_INFO_OPTIONS,
        payload: response.data,
      })
    } else {
      yield put({
        type: DECODE_VIN_FAILED,
        payload: { error: response?.data?.message },
      });
    }

  } catch (error) {
    yield put({
      type: DECODE_VIN_FAILED,
      payload: {
        error: error.message || 'Unexpected error',
      },
    });
  }
}

function* submitFee(action) {
  try {
    const state = yield select();
    const { locationInfo, vehicleInfo, transactionInfo } = state.forms;

    const combinedPayload = {
      ...locationInfo,
      ...vehicleInfo,
      ...transactionInfo,
    };

    yield put({
      type: SAVE_FEES_FORM_DATA,
      payload: combinedPayload,
    });

    const response = yield call(Api.submitFee, combinedPayload);

    if (response?.status === 200) {
      yield put(submitFeeSucess(response.data));
      if (action.navigate && action.path){
        action.navigate(action.path);
      }
      else if(action.defaultNaviagtion) {
        action.navigate('feesOutput');
      }
    } else {
      yield put({
        type: SUBMIT_FEES_FAILED,
        payload: { error: response?.data?.message || 'Unexpected error in fees form submission'},
      });
    }

  } catch (error) {
    yield put({
      type: SUBMIT_FEES_FAILED,
      payload: {
        error: error.message || 'Unexpected error in fees form submission',
      },
    });
  }
}

function* feesSaga() {
  yield takeLatest(DECODE_ZIP, decodeZip);
  yield takeLatest(DECODE_VIN, decodeVin);
  yield takeLatest(SUBMIT_FEES_FORM, submitFee);
}

export default feesSaga;
